import { useNavigate } from "react-router-dom";
import Container from "../../../components/layout/Container";
import { HeaderTitle } from "../../../components/header/Header";
import { STYLE_REPORT_CONTAIN } from "../../../utils/useStyle";
import { HeaderReport } from "../components/header.main";
import { useTaxStore } from "../../../_store/taxplanStore";
import {
  HeaderTableReport,
  HeaderTitleTableReport,
  TableReport,
} from "../components/table.main";
import TabPanelReport from "../components/tab.main";
import { useEffect, useMemo, useState } from "react";
import { result } from "lodash";
import numeral from "numeral";
import { first_reload } from "../../tax_plan/functions/firstLoad";
import { MTButton } from "../../../components/button/MTButton";
import { cn } from "../../../utils/useFunctions";
import HalfChartMain from "../../../components/chart/HalfChartMain";
import { calculateTax, checkSum } from "../../tax_plan/functions";
import { ICON_BAHT, ICON_GRAPH } from "../../../utils/useIcons";
import {
  TabThreeExpenseCalculation,
  TabThreeSumIncomeCalculation,
  TabThreeWithHoldingTax,
} from "../../../functions/taxFucntion/premium/tab3function";
import { useUserStore } from "../../../_store/userStore";
import {
  ExpenstDetail,
  IncomeDetail,
  IncomeTab4Calculation,
  sum408RecieveMoney,
  sum408property,
} from "../../../functions/taxFucntion/premium/tab4function";
import { numberWithoutComma } from "../../balance/component/VIDrawerDebt.Main";
import { TaxHeirachyPDF } from "../../../functions/pdfGenerateFunction/pdfFunction";
import { ExceptionLists } from "../../../functions/taxFucntion/taxHeirachy";
import { useBalanceStore } from "../../../_store/balanceStore";
import { calculateCurrentTaxPlanDeductionTotal } from "../../../functions/taxFucntion/current-tax-calculation";

const GraphSection = ({
  userData,
  balanceData,
  taxData,
  getCaltax,
  displaySumAfterTaxPaid,
  displayTaxPaid,
  displaySumTax,
  checkPercent,
}) => {
  return (
    <div>
      <div className=" px-2.5">
        <HalfChartMain
          chartWidth={"w-[180px] mt-5"}
          fontSize="text-2xl"
          text={false}
          value={`0`}
          beforevalue={getCaltax()}
          aftervalue={taxData?.after_tax_paid}
          maxvalue={displayTaxPaid}
          mtText="-mt-20"
        />
        <div className=" flex justify-center gap-2.5 w-full -mt-10 ">
          <div
            className={`bg-gray50 rounded-md py-[7px] px-2 w-20 text-mainblue text-sm font-semibold  h-6 flex gap-[5px] justify-center items-center`}
          >
            <ICON_GRAPH className="w-6 h-6 text-maincyan " />
            <span className=" flex-none"> {checkPercent()} %</span>
          </div>
          <div
            className={`bg-gray50 rounded-md py-[7px] px-2 w-20 text-mainblue text-sm font-semibold  h-6 flex gap-[5px] justify-center items-center`}
          >
            <ICON_BAHT className="w-6 h-6 text-maincyan " />
            {numeral(displaySumTax).format("0,0")}
          </div>
        </div>
        <div className="flex flex-col space-y-0.5 mt-1 text-sm">
          {[
            {
              title: "ก่อนวางแผน",
              value: String(getCaltax()) === "Infinity" ? "0" : getCaltax(),
              classNameValue: "text-mainred",
            },
            {
              title: "หลังวางแผน",
              value:
                String(displaySumAfterTaxPaid()) === "Infinity"
                  ? "0"
                  : displaySumAfterTaxPaid(),
              classNameValue: "text-maingreen",
            },
            {
              title: "ภาษีหัก ณ ที่จ่าย",
              value: userData?.is_premium
                ? TabThreeWithHoldingTax(taxData, balanceData)
                : taxData?.tax_withholding || 0,
              classNameValue: "text-mainblue",
            },
          ]?.map((item, index) => {
            return (
              <div key={index} className="flex justify-between">
                <div className=" font-medium text-black">{item?.title}</div>
                <div className={cn("  font-medium")}>
                  <span
                    className={cn(" mr-2.5 font-bold", item?.classNameValue)}
                  >
                    {" "}
                    {numeral(item?.value).format("0,0")}
                  </span>{" "}
                  บาท
                </div>
              </div>
            );
          })}
        </div>
        <div className=" flex justify-center items-center gap-[5px] font-bold mt-1 text-sm">
          <div className=" text-maincyan">
            {Number(taxData?.final_tax || 0) +
              sum408property(taxData, balanceData) +
              sum408RecieveMoney(taxData) +
              Number(taxData?.tax_QuitJob?.moreTax || 0) <
            0
              ? "ขอคืนได้อีก"
              : "ภาษีที่ต้องจ่าย"}
          </div>
          <div className=" text-mainorange">
            {numeral(
              Math.abs(
                Number(taxData?.final_tax || 0) +
                  sum408property(taxData, balanceData) +
                  sum408RecieveMoney(taxData) +
                  Number(taxData?.tax_QuitJob?.moreTax || 0)
              )
            )?.format("0,0")}{" "}
            บาท
          </div>
        </div>
      </div>
    </div>
  );
};

const TableTax = ({ taxData, table_income, table_expense, userData }) => {
  return (
    <div className="bg-gray50 rounded-[20px] w-full h-ful p-3">
      <TableReport
        headTable="แหล่งที่มาของรายรับ"
        data={table_income}
        isHeadMonth={false}
      />
      <div className="border-b border-gray55 mt-2.5 w-full "></div>
      <TableReport
        headTable="แหล่งที่มาของรายจ่าย"
        data={table_expense}
        isHeadMonth={false}
      />
    </div>
  );
};

const ExplanSection = ({
  userData,
  balanceData,
  taxData,
  isTab,
  sumDeductionBF,
  sumExceptionBF,
  sumDeductionAF,
  sumExceptionAF,
}) => {
  const netIncome =
    Number(
      numberWithoutComma(
        userData?.is_premium
          ? IncomeTab4Calculation(taxData, balanceData)
          : taxData.tax_income
      ) || 0
    ) -
    (Number(
      userData?.is_premium
        ? ExpenstDetail(taxData, balanceData)?.reduce((total, num) => {
            return total + Number(num?.value);
          }, 0)
        : taxData?.deduction_expenses || 0
    ) +
      (isTab === "before" ? Number(sumDeductionBF) : Number(sumDeductionAF)) +
      (isTab === "before" ? Number(sumExceptionBF) : Number(sumExceptionAF)));

  return (
    <div className=" text-center flex flex-col gap-[6px]">
      <div className=" text-base font-medium ">
        (รายรับ - หักค่าใช้จ่าย + หักค่าลดหย่อน + หักค่ายกเว้น ={" "}
        <span className="text-mainblue font-semibold">เงินได้สุทธิ</span>)
      </div>
      <div className="text-gray90 text-xs">
        (รายรับ - หักค่าใช้จ่าย + หักค่าลดหย่อน + หักค่ายกเว้น = เงินได้สุทธิ)
      </div>
      <div className=" text-base font-medium text-maincyan">
        เงินได้สุทธิ{" "}
        <span className=" text-mainblue font-semibold">
          {numeral(netIncome < 0 ? 0 : netIncome)?.format("0,0")}
        </span>
      </div>
    </div>
  );
};

const BeforeTable = ({ deductionItems, total, taxData }) => {
  const sumDeduction = TaxHeirachyPDF(taxData)?.reduce((total, acc) => {
    if (ExceptionLists.includes(acc?.title)) {
      return total + 0;
    }

    return total + Number(acc?.value2 || 0);
  }, 0);

  const sumException = TaxHeirachyPDF(taxData)
    ?.filter((item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ" && item?.value) {
        return item;
      }
      if (ExceptionLists.includes(item?.title) && item?.value) {
        return item;
      }
    })
    ?.reduce((total, acc) => {
      if (acc?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        if (acc?.value2 >= 10000) {
          return total + Number(acc?.value2) - 10000;
        } else {
          return total + Number(acc?.value2);
        }
      }
      return total + Number(acc?.value2);
    }, 0);

  return (
    <div>
      <HeaderTableReport
        title="รายการลดหย่อนต่อปี"
        // textjusify="text-center"
        monthly=""
      />
      <HeaderTitleTableReport
        img={`/images/proporty_asset2.png`}
        title={"ค่าลดหย่อน"}
      />
      <div className="bg-[#F9F9F9] py-1 rounded-[10px]  px-2 items-center font-semibold text-mainblue text-sm">
        {TaxHeirachyPDF(taxData)
          ?.filter((item) => {
            if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
              return item;
            }
            if (!ExceptionLists.includes(item?.title)) {
              return item;
            }
          })
          ?.map((item, index) => {
            if (ExceptionLists.includes(item?.title)) {
              return;
            }

            return (
              <div key={index} className={cn(" ")}>
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className=" text-black">{item?.title}</div>
                  <div>{numeral(item?.value2).format("0,0")} บาท</div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="flex justify-between space-x-1 mt-1 text-base">
        <div className=" text-black">รวม</div>
        <div className=" text-maincyan">
          {numeral(sumDeduction).format("0,0")} บาท
        </div>
      </div>
      <HeaderTitleTableReport
        img={`/images/proporty_asset2.png`}
        title={"ค่ายกเว้น"}
      />
      <div className="bg-[#F9F9F9] py-1 rounded-[10px]  px-2 items-center font-semibold text-mainblue text-sm">
        {TaxHeirachyPDF(taxData)?.map((item, index) => {
          if (
            ExceptionLists.includes(item?.title) &&
            item?.value !== 0 &&
            item?.value !== undefined
          ) {
            return (
              <div key={index} className={cn(" ")}>
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className=" text-black">{item?.title}</div>
                  <div>{numeral(item?.value2).format("0,0")} บาท</div>
                </div>
              </div>
            );
          }

          if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
            return (
              <div key={index} className={cn(" ")}>
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className=" text-black">{item?.title}</div>
                  <div>
                    {item?.value2 >= 10000
                      ? numeral(item?.value2 - 10000).format("0,0")
                      : numeral(item?.value2).format("0,0")}{" "}
                    บาท
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
      <div className="flex justify-between space-x-1 mt-1 text-base">
        <div className=" text-black">รวม</div>
        <div className=" text-maincyan">
          {numeral(sumException).format("0,0")} บาท
        </div>
      </div>
    </div>
  );
};

const AfterTable = ({ deductionItems2, total2, taxData }) => {
  const sumDeduction = TaxHeirachyPDF(taxData, () => {}, "four")?.reduce(
    (total, acc) => {
      if (ExceptionLists.includes(acc?.title)) {
        return total + 0;
      }

      return total + Number(acc?.value2 || 0);
    },
    0
  );

  const sumException = TaxHeirachyPDF(taxData, () => {}, "four")
    ?.filter((item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ" && item?.value) {
        return item;
      }
      if (ExceptionLists.includes(item?.title) && item?.value) {
        return item;
      }
    })
    ?.reduce((total, acc) => {
      if (acc?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        if (acc?.value2 >= 10000) {
          return total + Number(acc?.value2) - 10000;
        } else {
          return total + Number(acc?.value2);
        }
      }
      return total + Number(acc?.value2);
    }, 0);

  return (
    <div>
      <HeaderTableReport
        title="รายการลดหย่อนต่อปี"
        // textjusify="text-center"
        monthly=""
      />
      <HeaderTitleTableReport
        img={`/images/proporty_asset2.png`}
        title={"ค่าลดหย่อน"}
      />
      <div className="bg-[#F9F9F9] py-1 rounded-[10px]  px-2 items-center font-semibold text-mainblue text-sm">
        {TaxHeirachyPDF(taxData, () => {}, "four")
          ?.filter((item) => {
            if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
              return item;
            }
            if (!ExceptionLists.includes(item?.title)) {
              return item;
            }
          })
          ?.map((item, index) => {
            if (ExceptionLists.includes(item?.title)) {
              return;
            }

            return (
              <div key={index} className={cn(" ")}>
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className=" text-black">{item?.title}</div>
                  <div>{numeral(item?.value2).format("0,0")} บาท</div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="flex justify-between space-x-1 mt-1 text-base">
        <div className=" text-black">รวม</div>
        <div className=" text-maincyan">
          {numeral(sumDeduction).format("0,0")} บาท
        </div>
      </div>
      <HeaderTitleTableReport
        img={`/images/proporty_asset2.png`}
        title={"ค่ายกเว้น"}
      />
      <div className="bg-[#F9F9F9] py-1 rounded-[10px]  px-2 items-center font-semibold text-mainblue text-sm">
        {TaxHeirachyPDF(taxData, () => {}, "four")?.map((item, index) => {
          if (
            ExceptionLists.includes(item?.title) &&
            item?.value2 !== 0 &&
            item?.value2 !== undefined
          ) {
            return (
              <div key={index} className={cn(" ")}>
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className=" text-black">{item?.title}</div>
                  <div>{numeral(item?.value2).format("0,0")} บาท</div>
                </div>
              </div>
            );
          }

          if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
            return (
              <div key={index} className={cn(" ")}>
                <div
                  key={index}
                  className="flex justify-between space-x-1 mt-1"
                >
                  <div className=" text-black">{item?.title}</div>
                  <div>
                    {item?.value2 >= 10000
                      ? numeral(item?.value2 - 10000).format("0,0")
                      : numeral(item?.value2).format("0,0")}{" "}
                    บาท
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
      <div className="flex justify-between space-x-1 mt-1 text-base">
        <div className=" text-black">รวม</div>
        <div className=" text-maincyan">
          {numeral(sumException).format("0,0")} บาท
        </div>
      </div>
    </div>
  );
};

const ReportTaxPage = () => {
  const taxData = useTaxStore((state) => state.taxData);
  const userData = useUserStore((state) => state.userData);
  const balanceData = useBalanceStore((state) => state.balanceData);

  const displaySumBudget = () => {
    return calculateCurrentTaxPlanDeductionTotal(taxData);
  };

  const sumDeductionBF = useMemo(() => {
    return TaxHeirachyPDF(taxData)?.reduce((total, acc) => {
      if (ExceptionLists.includes(acc?.title)) {
        return total + 0;
      }

      return total + acc?.value2;
    }, 0);
  }, [taxData]);

  const sumExceptionBF = useMemo(
    () =>
      TaxHeirachyPDF(taxData)?.reduce((total, acc) => {
        if (
          ExceptionLists.includes(acc?.title) &&
          acc?.value2 !== 0 &&
          acc?.value2 !== undefined
        ) {
          return total + acc?.value2;
        }

        if (acc?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
          return total + acc?.value2;
        }

        return total;
      }, 0),
    [taxData]
  );

  const sumDeductionAF = useMemo(() => {
    return TaxHeirachyPDF(taxData, () => {}, "four")?.reduce((total, acc) => {
      if (ExceptionLists.includes(acc?.title)) {
        return total + 0;
      }

      return total + Number(acc?.value2 || 0);
    }, 0);
  }, [taxData]);

  const sumExceptionAF = useMemo(
    () =>
      TaxHeirachyPDF(taxData, () => {})?.reduce((total, acc) => {
        if (
          ExceptionLists.includes(acc?.title) &&
          acc?.value2 !== 0 &&
          acc?.value2 !== undefined
        ) {
          return total + acc?.value2;
        }

        if (acc?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
          return total + acc?.value2;
        }

        return total;
      }, 0),
    [taxData]
  );

  const navigate = useNavigate();
  const [isTab, setTab] = useState("before");

  const table_income = IncomeDetail(taxData, balanceData)?.map((item) => {
    return {
      source: item?.label,
      source_subtitle: item?.source_subtitle,
      yearly: item?.value,
      icon: item?.icon,
      head: item?.head,
    };
  });


  // const table_expense = [
  //   {
  //     source: "เงินเดือนค่าจ้างที่ได้รับจากบริษัทฯ บุคคลทั่วไป ฯลฯ",
  //     source_subtitle: "(อัตราค่าใช้จ่ายร้อยละ 50)",
  //     yearly: "100,000",
  //     icon: "/images/outcome-report.png",
  //     head: "หักค่าใช้จ่าย",
  //   },
  // ];

  const table_expense = ExpenstDetail(taxData, balanceData)?.map((item) => {
    return {
      source: item?.label,
      source_subtitle: item?.source_subtitle,
      yearly: item?.value,
      icon: item?.icon,
      head: item?.head,
    };
  });

  //ก่อน
  const deductionItems = useMemo(() => {
    const newDeductionItems = [
      {
        label: "ลดหย่อนผู้มีเงินได้",
        value: 60000 || "",
      },
      {
        label: "คู่สมรส",
        value: taxData?.tax_spouse || "",
      },
      {
        label: "ลูก",
        value: taxData?.deduct_child || "",
      },
      {
        label: "แม่",
        value: taxData?.deduct_mother || "",
      },
      {
        label: "พ่อ",
        value: taxData?.deduct_father || "",
      },
      {
        label: "เลี้ยงดูคนพิการ",
        value: taxData?.deduct_disable_people || "",
      },
      {
        label: "เลี้ยงดูคนทุพพลภาพ",
        value: taxData?.deduct_disabilities_people || "",
      },
      {
        label: "เบี้ยประกันสุขภาพบิดามารดา ",
        value: taxData?.deduct_insurance_premiums_parents || "",
      },
    ];
    return newDeductionItems;
  }, [taxData]);

  const total = useMemo(() => {
    let sum_total = deductionItems?.reduce((acc, item) => {
      return Number(acc) + Number(item.value);
    }, 0);
    return Number(sum_total);
  }, [taxData]);

  //หลัง
  const deductionItems2 = useMemo(() => {
    const newDeductionItems = [
      {
        label: "ประกันชีวิต",
        value: taxData?.tax_plan_insurance_life || "",
      },
      {
        label: "ประกันสุขภาพ",
        value: taxData?.tax_plan_insurance_health || "",
      },
      {
        label: "ประกันชีวิตแบบบำนาญ",
        value: taxData?.tax_plan_insurance_annuity || "",
      },
    ];
    return newDeductionItems;
  }, [taxData]);

  const total2 = useMemo(() => {
    let sum_total = deductionItems2?.reduce((acc, item) => {
      return Number(acc) + Number(item.value);
    }, 0);
    return Number(sum_total);
  }, [taxData]);

  // กราฟภาษี
  const getCaltax = () => {
    let result = 0;
    result =
      taxData?.tax_income -
      taxData?.deduction_expenses -
      taxData?.deduct_summary;
    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData, balanceData) -
        TabThreeExpenseCalculation(taxData, balanceData) -
        taxData?.deduct_summary +
        sum408property(taxData, balanceData) +
        sum408RecieveMoney(taxData);
    }
    return calculateTax(result);
  };

  const displaySumAfterTaxPaid = () => {
    let result = 0;
    result =
      Number(taxData?.tax_income) -
      Number(taxData?.deduction_expenses) -
      Number(taxData?.deduct_summary_af);

    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData, balanceData) -
        TabThreeExpenseCalculation(taxData, balanceData) -
        Number(taxData?.deduct_summary || 0) -
        Number(displaySumBudget() || 0);
    }
    return calculateTax(result);
  };

  const displayTaxPaid = useMemo(() => {
    let result = calculateTax(taxData.tax_income);
    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData, balanceData) +
        sum408property(taxData, balanceData) +
        sum408RecieveMoney(taxData);
    }
    return result;
  }, [taxData?.tax_income]);

  const displaySumTax = useMemo(
    () => checkSum(getCaltax(), taxData?.after_tax_paid, 0, 0),
    [getCaltax(), taxData?.after_tax_paid, 0, 0]
  );

  const checkPercent = () => {
    let result = 0;
    result = ((getCaltax() - taxData?.after_tax_paid) / getCaltax()) * 100;
    if (isNaN(result)) {
      return 0;
    }
    return Number(result)?.toFixed(2);
  };

  useEffect(() => {
    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <Container>
      <div id="first_reload" className="pt-[14px]">
        <HeaderTitle
          title="รายงาน"
          isGoback
          onClickGoBack={() => {
            navigate("/report");
          }}
        />
        <div
          className={`${STYLE_REPORT_CONTAIN} flex flex-col gap-5 mb-[30px]`}
        >
          <HeaderReport
            icon={"/images/tax-report.png"}
            title={"แผนภาษี"}
            className={" z-20"}
          />
          <GraphSection
            userData={userData}
            balanceData={balanceData}
            taxData={taxData}
            getCaltax={getCaltax}
            displaySumAfterTaxPaid={displaySumAfterTaxPaid}
            displayTaxPaid={displayTaxPaid}
            displaySumTax={displaySumTax}
            checkPercent={checkPercent}
          />
          <TableTax
            table_income={table_income}
            table_expense={table_expense}
            taxData={taxData}
          />
          <div className="bg-gray50 rounded-[20px] w-full h-ful">
            <div className=" p-3">
              <TabPanelReport
                taxData={taxData}
                title_tab1={"ก่อนวางแผน"}
                title_tab2={"หลังวางแผน"}
                onTab1={() => setTab("before")}
                tab1={isTab === "before" ? true : false}
                onTab2={() => setTab("after")}
                tab2={isTab === "after" ? true : false}
              />
            </div>
            <div className=" p-3 bg-[#FCFCFC] rounded-b-[20px]">
              {isTab === "before" ? (
                <div>
                  <BeforeTable
                    deductionItems={deductionItems}
                    total={total}
                    taxData={taxData}
                  />
                </div>
              ) : (
                <div>
                  <AfterTable
                    deductionItems2={deductionItems2}
                    total2={total2}
                    taxData={taxData}
                  />
                </div>
              )}
            </div>
          </div>

          <div className=" bg-gray50 rounded-[20px] w-full h-full px-[15px] py-2.5 flex flex-col gap-[6px]">
            <div className=" flex justify-between">
              <div className=" font-medium">รายรับ</div>
              <div className=" font-bold text-mainblue">
                {numeral(
                  userData?.is_premium
                    ? IncomeTab4Calculation(taxData, balanceData)
                    : taxData.tax_income
                )?.format("0,0")}
              </div>
            </div>
            <div className=" flex justify-between">
              <div className=" font-medium">หักค่าใช้จ่าย</div>
              <div className=" font-bold text-mainblue">
                {numeral(
                  userData?.is_premium
                    ? ExpenstDetail(taxData, balanceData)?.reduce(
                        (total, num) => {
                          return total + Number(num?.value);
                        },
                        0
                      )
                    : taxData?.deduction_expenses
                )?.format("0,0")}
              </div>
            </div>
            <div className=" flex justify-between">
              <div className=" font-medium">หักค่าลดหย่อน</div>
              <div className=" font-bold text-mainblue">
                {isTab === "before"
                  ? numeral(sumDeductionBF)?.format("0,0")
                  : numeral(sumDeductionAF)?.format("0,0")}
              </div>
            </div>
            <div className=" flex justify-between">
              <div className=" font-medium">หักค่ายกเว้น</div>
              <div className=" font-bold text-mainblue">
                {isTab === "before"
                  ? numeral(sumExceptionBF)?.format("0,0")
                  : numeral(sumExceptionAF)?.format("0,0")}
              </div>
            </div>
          </div>
          <ExplanSection
            userData={userData}
            balanceData={balanceData}
            taxData={taxData}
            isTab={isTab}
            sumDeductionBF={sumDeductionBF}
            sumExceptionBF={sumExceptionBF}
            sumDeductionAF={sumDeductionAF}
            sumExceptionAF={sumExceptionAF}
          />
          <div className=" flex justify-center ">
            <MTButton
              onClick={() => {
                navigate("/report");
              }}
              text="ย้อนกลับ"
              color="bg-white"
              border="border border-maincyan"
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ReportTaxPage;
